var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-title" }, [
    _c(
      "div",
      {
        staticClass: "task-table-header",
        class: _vm.getSortingClass(_vm.customField.field_id)
      },
      [
        _c(
          "div",
          {
            staticClass: "field-label cursor-pointer",
            class: !_vm.multipleTasks ? "responsive-labels" : "",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.sortTasks({
                  fieldId: _vm.customField.field_id,
                  sortKey:
                    _vm.sortEnabledFields[
                      _vm.sortEnabledFields.indexOf(_vm.customField.field_key)
                    ],
                  deliverables: _vm.fullDeliverables,
                  namespace: _vm.namespace
                })
              }
            }
          },
          [
            _vm.customField.label_id !== null
              ? _c(
                  "div",
                  [
                    _c("NewCustomFieldLabel", {
                      attrs: {
                        customField: _vm.customField,
                        taskCount: _vm.taskCount,
                        deliverableId: _vm.deliverable.id,
                        namespace: _vm.namespace
                      }
                    })
                  ],
                  1
                )
              : _c("div", [
                  _vm.sortEnabledFields.indexOf(_vm.customField.field_key) != -1
                    ? _c(
                        "span",
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.customField.label) +
                              "\n          "
                          ),
                          _c("SortTaskControl")
                        ],
                        1
                      )
                    : _vm._e()
                ])
          ]
        ),
        _vm._v(" "),
        _vm.customField.field_type == "wysiwyg" && _vm.customField.updated_at
          ? _c("div", { staticClass: "last-updated" }, [
              _vm._v(
                "Last updated " +
                  _vm._s(
                    _vm._f("moment")(
                      _vm.customField.updated_at,
                      "MMM D HH:mm a"
                    )
                  )
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: _vm.getClasses(_vm.customField.field_type),
        on: { click: _vm.showField }
      },
      [
        _vm.customField.field_type == "wysiwyg"
          ? _c(
              "div",
              { staticClass: "field-wrap" },
              [
                _c("perfect-scrollbar", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass:
                    "exclude-outside-click field-value textarea wysiwyg",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.customField.value || "Click to set..."
                    )
                  }
                }),
                _vm._v(" "),
                _c("ckeditor", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "customInput",
                  attrs: {
                    editorUrl: "/js/ckeditor/ckeditor.js",
                    id: "custom-field-" + _vm._uid,
                    config: _vm.editorConfig
                  },
                  on: {
                    blur: function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    }
                  },
                  model: {
                    value: _vm.customField.value,
                    callback: function($$v) {
                      _vm.$set(_vm.customField, "value", $$v)
                    },
                    expression: "customField.value"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "textarea"
          ? _c("div", { staticClass: "field-wrap" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    },
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "exclude-outside-click field-value text-hover-bg pt-20",
                  attrs: { title: _vm.customField.value || "" }
                },
                [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "custom-field" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editing,
                      expression: "editing"
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customField.value,
                      expression: "customField.value"
                    }
                  ],
                  ref: "customInput",
                  staticClass: "form-control custom-inputs",
                  attrs: { rows: _vm.rows },
                  domProps: { value: _vm.customField.value },
                  on: {
                    change: function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    },
                    blur: function($event) {
                      _vm.editing = false
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.customField, "value", $event.target.value)
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "select"
          ? _c("div", { staticClass: "field-wrap" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click field-value text-hover-bg"
                },
                [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-field select-dropdown" },
                [
                  _c("multiselect", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    ref: "customInput",
                    attrs: {
                      "show-labels": false,
                      options: _vm.getOptions,
                      multiple: false
                    },
                    on: {
                      close: function($event) {
                        _vm.editing = false
                      },
                      input: function($event) {
                        _vm.updateFieldValue(_vm.customField)
                        _vm.editing = false
                      }
                    },
                    model: {
                      value: _vm.customField.value,
                      callback: function($$v) {
                        _vm.$set(_vm.customField, "value", $$v)
                      },
                      expression: "customField.value"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "status"
          ? _c(
              "div",
              {
                staticClass: "field-wrap no-icon",
                class: {
                  "can-update-task-status":
                    _vm.userAbilities.updateTaskStatus ||
                    _vm.isTaskAssignedToLoggedInUser
                }
              },
              [
                _vm.customField.value
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "exclude-outside-click field-value status-field-value",
                        style: {
                          backgroundColor:
                            _vm.parseValue(_vm.customField.value).color ||
                            _vm.customField.value.color
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.parseValue(_vm.customField.value).name ||
                              _vm.customField.value.name
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.customField.value
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editing,
                            expression: "!editing"
                          }
                        ],
                        staticClass: "exclude-outside-click field-value"
                      },
                      [_vm._v("Click to set...")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-field status-field exclude-outside-click"
                  },
                  [
                    false
                      ? _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editing,
                              expression: "editing"
                            }
                          ],
                          staticClass: "custom-field-outside-bg-mobile"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("multiselect", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editing,
                          expression: "editing"
                        },
                        {
                          name: "field-dismiss",
                          rawName: "v-field-dismiss",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      ref: "customInput",
                      attrs: {
                        searchable: true,
                        options: _vm.getOptions,
                        "custom-label": _vm.customLabel,
                        "show-labels": false
                      },
                      on: {
                        close: function($event) {
                          _vm.editing = false
                        },
                        input: _vm.handleFieldValueUpdate
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      color: "var(--wf-secondary)",
                                      borderRadius: "5px",
                                      backgroundColor: props.option.color,
                                      height: "40px",
                                      lineHeight: "40px",
                                      textAlign: "center"
                                    }
                                  },
                                  [_vm._v(_vm._s(props.option.name))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        449398395
                      ),
                      model: {
                        value: _vm.selectedStatus,
                        callback: function($$v) {
                          _vm.selectedStatus = $$v
                        },
                        expression: "selectedStatus"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "users"
          ? _c("div", { staticClass: "field-wrap field-wrap-users no-icon" }, [
              _c("div", { staticClass: "field-value exclude-outside-click" }, [
                _c("span", { staticClass: "info-bubbles" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "exclude-outside-click initials badge",
                      class: _vm.getColorClass(),
                      staticStyle: { display: "inline-block" },
                      attrs: { title: _vm.customField.userName },
                      on: { click: _vm.checkPosition }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("textInitials")(_vm.customField.userName))
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-multiselect-group" },
                  [
                    _c("plus-button"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editing,
                            expression: "editing"
                          }
                        ],
                        staticClass:
                          "custom-field user-field custom-multiselect"
                      },
                      [
                        _c("multiselect", {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.outside,
                              expression: "outside"
                            }
                          ],
                          ref: "customInput",
                          attrs: {
                            options: _vm.allActiveUsers,
                            "option-height": 42,
                            "show-labels": false,
                            multiple: false,
                            label: "name",
                            "track-by": "id"
                          },
                          on: {
                            close: function($event) {
                              _vm.editing = false
                            },
                            input: function($event) {
                              _vm.updateFieldValue(_vm.customField)
                              _vm.editing = false
                            }
                          },
                          model: {
                            value: _vm.selectedUser,
                            callback: function($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "datepicker"
          ? _c(
              "div",
              {
                ref: "refDatepickerWrapper",
                staticClass:
                  "field-wrap field-wrap-datepicker exclude-outside-click",
                on: {
                  click: function($event) {
                    return _vm.findPosition()
                  }
                }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass:
                      "exclude-outside-click field-value text-hover-bg"
                  },
                  [
                    _vm.customField.value
                      ? _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                _vm.customField.value,
                                "DD MMM, YYYY"
                              )
                            ) + " "
                          )
                        ])
                      : _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v("No Deadline")
                        ]),
                    _vm._v(" "),
                    _vm.isDateOverdue(_vm.customField)
                      ? _c("i", {
                          staticClass:
                            "fas fa-exclamation-circle date-overdue-icon",
                          attrs: { id: _vm.overdueToolTip(_vm.customField) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDateOverdue(_vm.customField)
                      ? _c(
                          "b-tooltip",
                          {
                            attrs: {
                              target: _vm.overdueToolTip(_vm.customField),
                              triggers: "hover"
                            }
                          },
                          [_vm._v("\n          Overdue!\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDateToday(_vm.customField)
                      ? _c("i", {
                          staticClass: "fas fa-calendar date-today-icon",
                          attrs: { id: _vm.overdueToolTip(_vm.customField) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDateToday(_vm.customField)
                      ? _c(
                          "b-tooltip",
                          {
                            attrs: {
                              target: _vm.overdueToolTip(_vm.customField),
                              triggers: "hover"
                            }
                          },
                          [_vm._v("\n          Due today!\n        ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    staticClass: "custom-field date-pick-field"
                  },
                  [
                    false
                      ? _c("div", {
                          staticClass: "custom-field-outside-bg-mobile"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "vuejs-datepicker",
                      {
                        directives: [
                          {
                            name: "field-dismiss",
                            rawName: "v-field-dismiss",
                            value: _vm.outside,
                            expression: "outside"
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editing,
                            expression: "editing"
                          }
                        ],
                        ref: "customDatepicker",
                        attrs: {
                          format: _vm.customDateFormat,
                          name: "due_date",
                          "input-class": "custom-datepicker form-control",
                          inline: true
                        },
                        on: {
                          input: function($event) {
                            return _vm.updateFieldValue(_vm.customField)
                          },
                          selected: function($event) {
                            _vm.dateSelected = true
                          }
                        },
                        model: {
                          value: _vm.customField.value,
                          callback: function($$v) {
                            _vm.$set(_vm.customField, "value", $$v)
                          },
                          expression: "customField.value"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "calender-header",
                            attrs: { slot: "beforeCalendarHeader" },
                            slot: "beforeCalendarHeader"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "remove-dl-btn",
                                attrs: { variant: "text" },
                                on: { click: _vm.resetDeadline }
                              },
                              [_vm._v("Remove Deadline")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "today-btn",
                                attrs: { variant: "text" },
                                on: { click: _vm.onToday }
                              },
                              [_vm._v("Today")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "file"
          ? _c("span", [_c("input", { attrs: { type: "file" } })])
          : _vm._e(),
        _vm._v(" "),
        _vm.customField.field_type == "radio"
          ? _c(
              "span",
              _vm._l(_vm.parseValue(_vm.customField.value_set), function(
                radioValue,
                index
              ) {
                return _c(
                  "label",
                  { key: "radio" + index, staticClass: "ml-2" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customField.value,
                          expression: "customField.value"
                        }
                      ],
                      attrs: { type: "radio" },
                      domProps: {
                        value: radioValue,
                        checked: _vm._q(_vm.customField.value, radioValue)
                      },
                      on: {
                        change: [
                          function($event) {
                            return _vm.$set(
                              _vm.customField,
                              "value",
                              radioValue
                            )
                          },
                          function($event) {
                            return _vm.updateFieldValue(_vm.customField)
                          }
                        ]
                      }
                    }),
                    _vm._v("\n        " + _vm._s(radioValue) + "\n      ")
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }